// extracted by mini-css-extract-plugin
export default {"root":"FileExtension_root__dUrGv","image":"FileExtension_image__IB5n7"};